import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import subjectsReducer from './slices/subjectsSlice';
import lessonsReducer from './slices/lessonsSlice';
import teachersReducer from './slices/teachersSlice';
import inquiriesReducer from './slices/inquiriesSlice';
import filesReducer from './slices/filesSlice';
import examsReducer from './slices/examsSlice';
import examSessionReducer from './slices/examSessionSlice';
import examHistoryReducer from './slices/examHistorySlice';
import subjectTeachersReducer from './slices/subjectTeachersSlice';
import teacherDetailsReducer from './slices/teacherDetailsSlice';
import teacherFilesReducer from './slices/teacherFilesSlice';
import teacherTestsReducer from './slices/teacherTestsSlice';
import questionBankReducer from './slices/questionBankSlice';
import ratingsReducer from './slices/ratingsSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import lessonDutiesReducer from './slices/lessonDutiesSlice';
import dutyDetailsReducer from './slices/dutyDetailsSlice';
import checkCodeReducer from './slices/checkCodeSlice';
import studentReportsReducer from './slices/studentReportsSlice';
import childTestsReducer from './slices/childTestsSlice';
import contactUsReducer from './slices/contactUsSlice';
import appSettingsReducer from './slices/appSettingsSlice';
import dayLessonsReducer from './slices/dayLessonsSlice';
import studentStatisticsReducer from './slices/studentStatisticsSlice';
import subjectBooksReducer from './slices/subjectBooksSlice';
import conversationsReducer from './slices/conversationsSlice';
import firebaseChatReducer from './slices/firebaseChatSlice';
import dutySessionReducer from './slices/dutySessionSlice';
import dutyRecordsReducer from './slices/dutyRecordsSlice';
import dutyStudentDetailsReducer from './slices/dutyStudentDetailsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    subjects: subjectsReducer,
    lessons: lessonsReducer,
    teachers: teachersReducer,
    inquiries: inquiriesReducer,
    files: filesReducer,
    exams: examsReducer,
    examSession: examSessionReducer,
    examHistory: examHistoryReducer,
    subjectTeachers: subjectTeachersReducer,
    teacherDetails: teacherDetailsReducer,
    teacherFiles: teacherFilesReducer,
    teacherTests: teacherTestsReducer,
    questionBank: questionBankReducer,
    ratings: ratingsReducer,
    subscription: subscriptionReducer,
    lessonDuties: lessonDutiesReducer,
    dutyDetails: dutyDetailsReducer,
    checkCode: checkCodeReducer,
    studentReports: studentReportsReducer,
    childTests: childTestsReducer,
    contactUs: contactUsReducer,
    appSettings: appSettingsReducer,
    dayLessons: dayLessonsReducer,
    studentStatistics: studentStatisticsReducer,
    subjectBooks: subjectBooksReducer,
    conversations: conversationsReducer,
    firebaseChat: firebaseChatReducer,
    dutySession: dutySessionReducer,
    dutyRecords: dutyRecordsReducer,
    dutyStudentDetails: dutyStudentDetailsReducer,
  },
}); 